// Конфигурация маршрутов приложения
import { lazy } from 'react';

// Ленивая загрузка страниц для оптимизации
const RegistrationPage = lazy(() => import('../containers/RegistrationPage/RegistrationPage'));
const AuthPage = lazy(() => import('../containers/AuthPage/AuthPage'));
const HomePage = lazy(() => import('../containers/HomePage/HomePage'));
const MyModelsPage = lazy(() => import('../containers/MyModelsPage/MyModelsPage'));
const ModelLibraryPage = lazy(() => import('../containers/ModelLibraryPage/ModelLibraryPage'));
const CategoryModelsPage = lazy(() => import('../containers/CategoryModelsPage/CategoryModelsPage'));
const FineTuningPage = lazy(() => import('../containers/FineTuningPage/FineTuningPage'));
const UsagePage = lazy(() => import('../containers/UsagePage/UsagePage'));
const ModelDetailPage = lazy(() => import('../containers/ModelDetailPage/ModelDetailPage'));
const ApiKeysPage = lazy(() => import('../containers/ApiKeysPage/ApiKeysPage'));
const McpPage = lazy(() => import('../containers/McpPage/McpPage'));
const SandboxPage = lazy(() => import('../containers/SandboxPage/SandboxPage'));
const AdminModelsPage = lazy(() => import('../containers/AdminModelsPage/AdminModelsPage'));
const AdminMonitoringPage = lazy(() => import('../containers/AdminMonitoringPage/AdminMonitoringPage'));
// Служебная страница дизайн-системы: каталог статусов всех доменов
const StatusCatalogPage = lazy(() => import('../containers/StatusCatalogPage/StatusCatalogPage'));

// Страницы RAG-проектов
const ProjectsPage = lazy(() => import('../containers/ProjectsPage/ProjectsPage'));
const ProjectCreatePage = lazy(() => import('../containers/ProjectCreatePage/ProjectCreatePage'));
const ProjectStoragePage = lazy(() => import('../containers/ProjectStoragePage/ProjectStoragePage'));
const ProjectLLMPage = lazy(() => import('../containers/ProjectLLMPage/ProjectLLMPage'));
const ProjectEmbeddingsPage = lazy(() => import('../containers/ProjectEmbeddingsPage/ProjectEmbeddingsPage'));
const ProjectSourcesPage = lazy(() => import('../containers/ProjectSourcesPage/ProjectSourcesPage'));
const ProjectOutputTypePage = lazy(() => import('../containers/ProjectOutputTypePage/ProjectOutputTypePage'));
const ProjectOutputConfigPage = lazy(() => import('../containers/ProjectOutputConfigPage/ProjectOutputConfigPage'));
const ProjectWorkspacePage = lazy(() => import('../containers/ProjectWorkspacePage/ProjectWorkspacePage'));
const ProjectChatPage = lazy(() => import('../containers/ProjectChatPage/ProjectChatPage'));
const ProjectDiagnosticsPage = lazy(() => import('../containers/ProjectDiagnosticsPage/ProjectDiagnosticsPage'));
const ProjectTelegramPage = lazy(() => import('../containers/ProjectTelegramPage/ProjectTelegramPage'));
const ProjectTelegramSettingsPage = lazy(() => import('../containers/ProjectTelegramSettingsPage/ProjectTelegramSettingsPage'));
const ProjectConfirmPage = lazy(() => import('../containers/ProjectConfirmPage/ProjectConfirmPage'));

// RAG-инстансы
const RagCreatePage = lazy(() => import('../containers/Rag/RagCreatePage'));
const RagHubPage = lazy(() => import('../containers/Rag/RagHubPage'));
const RagOverviewPage = lazy(() => import('../containers/Rag/RagOverviewPage'));
const RagConfigPage = lazy(() => import('../containers/Rag/RagConfigPage'));
const RagDbNameRedirect = lazy(() => import('../containers/Rag/RagDbNameRedirect'));
const RagDbNameRedirectChat = lazy(() => import('../containers/Rag/RagDbNameRedirect').then((m) => ({ default: m.RagDbNameRedirectChat })));
const RagDbNameRedirectConfig = lazy(() => import('../containers/Rag/RagDbNameRedirect').then((m) => ({ default: m.RagDbNameRedirectConfig })));
const RagDbNameRedirectOutput = lazy(() => import('../containers/Rag/RagDbNameRedirect').then((m) => ({ default: m.RagDbNameRedirectOutput })));
const LegacyRagRedirectLlm = lazy(() => import('../containers/Rag/LegacyRagRedirect').then((m) => ({ default: m.LegacyRagRedirectLlm })));
const LegacyRagRedirectEmbeddings = lazy(() => import('../containers/Rag/LegacyRagRedirect').then((m) => ({ default: m.LegacyRagRedirectEmbeddings })));
const LegacyRagRedirectOutputType = lazy(() => import('../containers/Rag/LegacyRagRedirect').then((m) => ({ default: m.LegacyRagRedirectOutputType })));
const LegacyRagRedirectOutputConfig = lazy(() => import('../containers/Rag/LegacyRagRedirect').then((m) => ({ default: m.LegacyRagRedirectOutputConfig })));
const LegacyRagRedirectConfirm = lazy(() => import('../containers/Rag/LegacyRagRedirect').then((m) => ({ default: m.LegacyRagRedirectConfirm })));
const LegacyRagRedirectTelegram = lazy(() => import('../containers/Rag/LegacyRagRedirect').then((m) => ({ default: m.LegacyRagRedirectTelegram })));
const LegacyRagRedirectTelegramSettings = lazy(() => import('../containers/Rag/LegacyRagRedirect').then((m) => ({ default: m.LegacyRagRedirectTelegramSettings })));
const LegacyRagRedirectChat = lazy(() => import('../containers/Rag/LegacyRagRedirect').then((m) => ({ default: m.LegacyRagRedirectChat })));
const LegacyRagRedirectDiagnostics = lazy(() => import('../containers/Rag/LegacyRagRedirect').then((m) => ({ default: m.LegacyRagRedirectDiagnostics })));
const LegacyRagRedirectSetup = lazy(() => import('../containers/Rag/LegacyRagRedirect').then((m) => ({ default: m.LegacyRagRedirectSetup })));
const ReportingAudiencePage = lazy(() => import('../containers/Reporting/AudiencePage/AudiencePage'));
const ReportingFunnelsPage = lazy(() => import('../containers/Reporting/FunnelsPage/FunnelsPage'));
const ReportingRetentionPage = lazy(() => import('../containers/Reporting/RetentionPage/RetentionPage'));
const CdpConfigsPage = lazy(() => import('../containers/Cdp/Configs/CdpConfigsPage'));
const CdpConfigCreatePage = lazy(() => import('../containers/Cdp/Configs/CdpConfigCreatePage'));
const CdpConfigVersionPage = lazy(() => import('../containers/Cdp/Configs/CdpConfigVersionPage'));
const CdpProfilesPage = lazy(() => import('../containers/Cdp/Profiles/CdpProfilesPage'));
const CdpProfilePage = lazy(() => import('../containers/Cdp/Profiles/CdpProfilePage'));
const CdpJobsPage = lazy(() => import('../containers/Cdp/Jobs/CdpJobsPage'));
const ProjectStorageExplorerPage = lazy(() => import('../containers/ProjectStorageExplorerPage/ProjectStorageExplorerPage'));
const CsvUploadPage = lazy(() => import('../containers/CsvUploadPage/CsvUploadPage'));

// Страницы интеграций и источников данных
const AddConnectionPage = lazy(() => import('../containers/AddConnectionPage/AddConnectionPage'));
const SourcesPage = lazy(() => import('../containers/SourcesPage/SourcesPage'));
const StoragesPage = lazy(() => import('../containers/StoragesPage/StoragesPage'));
const IntegrationsPage = lazy(() => import('../containers/IntegrationsPage/IntegrationsPage'));
const IntegrationPage = lazy(() => import('../containers/IntegrationPage/IntegrationPage'));
const IntegrationAddSourcePage = lazy(() => import('../containers/IntegrationAddSourcePage/IntegrationAddSourcePage'));
const IntegrationAddStoragePage = lazy(() => import('../containers/IntegrationAddStoragePage/IntegrationAddStoragePage'));
const IntegrationConfigPage = lazy(() => import('../containers/IntegrationConfigPage/IntegrationConfigPage'));
const IntegrationConfigureRedirect = lazy(() => import('../containers/IntegrationConfigPage/IntegrationConfigureRedirect'));
const UserConnectionsPage = lazy(() => import('../containers/UserConnectionsPage/UserConnectionsPage'));
const TasksPage = lazy(() => import('../containers/TasksPage/TasksPage'));
const SourceDetailsPage = lazy(() => import('../containers/SourceDetailsPage/SourceDetailsPage'));

// Библиотека объектов
const ObjectLibraryPage = lazy(() => import('../containers/ObjectLibraryPage/ObjectLibraryPage'));
const ObjectDetailsPage = lazy(() => import('../containers/ObjectDetailsPage/ObjectDetailsPage'));

// Feature Store (события, шаблонизатор)
const FsTemplatesPage = lazy(() => import('../containers/FeatureStore/Templates/TemplatesPage'));
const FsTemplateCreatePage = lazy(() => import('../containers/FeatureStore/Templates/TemplateCreatePage'));
const FsTemplatePage = lazy(() => import('../containers/FeatureStore/Templates/TemplatePage'));
const FsEventsCatalogPage = lazy(() => import('../containers/FeatureStore/Events/EventsCatalogPage'));
const FsTablesListPage = lazy(() => import('../containers/FeatureStore/Tables/TablesListPage'));
const FsTablePage = lazy(() => import('../containers/FeatureStore/Tables/TablePage'));

// Датасеты (Data core) — контракт между хранилищем и ML
// Рекомендательные кампании (recsys): кампании, модели, места показа
const CampaignsListPage = lazy(() => import('../containers/Campaigns/CampaignsListPage'));
const CampaignWizardPage = lazy(() => import('../containers/Campaigns/CampaignWizardPage'));
const CampaignPage = lazy(() => import('../containers/Campaigns/CampaignPage'));
const ModelsListPage = lazy(() => import('../containers/Campaigns/ModelsListPage'));
const ModelPage = lazy(() => import('../containers/Campaigns/ModelPage'));
const PlacementsListPage = lazy(() => import('../containers/Campaigns/PlacementsListPage'));
const PlacementPage = lazy(() => import('../containers/Campaigns/PlacementPage'));

// Цепочки интеграций — граф запусков «после завершения»
const ChainsListPage = lazy(() => import('../containers/Chains/ChainsListPage'));
const ChainPage = lazy(() => import('../containers/Chains/ChainPage'));
const ChainEditorPage = lazy(() => import('../containers/Chains/ChainEditorPage'));

const DatasetsListPage = lazy(() => import('../containers/Datasets/DatasetsListPage'));
const DatasetWizardPage = lazy(() => import('../containers/Datasets/DatasetWizardPage'));
const DatasetPage = lazy(() => import('../containers/Datasets/DatasetPage'));
const FsEventEditorPage = lazy(() => import('../containers/FeatureStore/Events/EventEditorPage'));
const FsEventPage = lazy(() => import('../containers/FeatureStore/Events/EventPage'));
const MonitoringListPage = lazy(() => import('../containers/Monitoring/MonitoringListPage'));
const MonitorPage = lazy(() => import('../containers/Monitoring/MonitorPage'));
const MonitoringAlertsPage = lazy(() => import('../containers/Monitoring/AlertsPage'));
const FsParamsCatalogPage = lazy(() => import('../containers/FeatureStore/Params/ParamsCatalogPage'));
const FsValuesDiscoveryPage = lazy(() => import('../containers/FeatureStore/Values/ValuesDiscoveryPage'));
const FsParamPage = lazy(() => import('../containers/FeatureStore/Params/ParamPage'));
const FsFeaturesListPage = lazy(() => import('../containers/FeatureStore/Features/FeaturesListPage'));
const FsFeatureCreatePage = lazy(() => import('../containers/FeatureStore/Features/FeatureCreatePage'));
const FsFeaturePage = lazy(() => import('../containers/FeatureStore/Features/FeaturePage'));
const LegalPage = lazy(() => import('../containers/LegalPage/LegalPage'));

/**
 * Конфигурация маршрутов
 * @property {string} path - путь маршрута
 * @property {React.LazyExoticComponent} component - компонент страницы
 * @property {boolean} isPublic - публичный маршрут (не требует авторизации)
 * @property {boolean} usePathKey - использовать pathname как key (для перерендера)
 */
export const routesConfig = [
  // Публичные маршруты
  { path: '/auth', component: AuthPage, isPublic: true },
  { path: '/register', component: RegistrationPage, isPublic: true },
  { path: '/legal/:docType', component: LegalPage, isPublic: true },

  // Основные защищённые маршруты
  { path: '/', component: HomePage },
  { path: '/my-models', component: MyModelsPage, requiresInferenceAccess: true },
  { path: '/model-library', component: ModelLibraryPage, requiresInferenceAccess: true },
  { path: '/category/:category', component: CategoryModelsPage, requiresInferenceAccess: true },
  { path: '/fine-tuning', component: FineTuningPage, requiresInferenceAccess: true },
  { path: '/usage', component: UsagePage, requiresInferenceAccess: true },
  { path: '/api-keys', component: ApiKeysPage, requiresInferenceAccess: true },
  { path: '/mcp', component: McpPage, requiresInferenceAccess: true },
  { path: '/admin/models', component: AdminModelsPage, requiresAdminAccess: true },
  { path: '/admin/monitoring', component: AdminMonitoringPage, requiresAdminAccess: true },
  { path: '/admin/status-catalog', component: StatusCatalogPage, requiresAdminAccess: true },
  { path: '/sandbox', component: SandboxPage, requiresInferenceAccess: true },
  { path: '/model/*', component: ModelDetailPage, usePathKey: true, requiresInferenceAccess: true },

  // Проекты (workspace)
  { path: '/projects', component: ProjectsPage },
  { path: '/projects/create', component: ProjectCreatePage },
  { path: '/projects/:project_id/storage', component: ProjectStoragePage },
  { path: '/projects/:project_id/sources', component: ProjectSourcesPage },
  { path: '/projects/:project_id/setup', component: LegacyRagRedirectSetup },

  // RAG — маршруты с db_name (меню Inference)
  { path: '/rag', component: RagDbNameRedirect },
  { path: '/rag/chat', component: RagDbNameRedirectChat },
  { path: '/rag/config', component: RagDbNameRedirectConfig },
  { path: '/rag/output', component: RagDbNameRedirectOutput },

  // RAG — canonical paths
  { path: '/projects/:project_id/rags/create', component: RagCreatePage },
  { path: '/projects/:project_id/rags', component: RagHubPage },
  { path: '/projects/:project_id/rags/:rag_id', component: RagOverviewPage },
  { path: '/projects/:project_id/rags/:rag_id/llm', component: ProjectLLMPage },
  { path: '/projects/:project_id/rags/:rag_id/embeddings', component: ProjectEmbeddingsPage },
  { path: '/projects/:project_id/rags/:rag_id/output-type', component: ProjectOutputTypePage },
  { path: '/projects/:project_id/rags/:rag_id/output-config', component: ProjectOutputConfigPage },
  { path: '/projects/:project_id/rags/:rag_id/confirm', component: ProjectConfirmPage },
  { path: '/projects/:project_id/rags/:rag_id/telegram', component: ProjectTelegramPage },
  { path: '/projects/:project_id/rags/:rag_id/telegram/settings', component: ProjectTelegramSettingsPage },
  { path: '/projects/:project_id/rags/:rag_id/chat', component: ProjectChatPage },
  { path: '/projects/:project_id/rags/:rag_id/diagnostics', component: ProjectDiagnosticsPage },
  { path: '/projects/:project_id/rags/:rag_id/config', component: RagConfigPage },

  // Legacy RAG URLs → redirect
  { path: '/projects/:project_id/llm', component: LegacyRagRedirectLlm },
  { path: '/projects/:project_id/embeddings', component: LegacyRagRedirectEmbeddings },
  { path: '/projects/:project_id/output-type', component: LegacyRagRedirectOutputType },
  { path: '/projects/:project_id/output-config', component: LegacyRagRedirectOutputConfig },
  { path: '/projects/:project_id/confirm', component: LegacyRagRedirectConfirm },
  { path: '/projects/:project_id/telegram', component: LegacyRagRedirectTelegram },
  { path: '/projects/:project_id/telegram/settings', component: LegacyRagRedirectTelegramSettings },
  { path: '/projects/:project_id/chat', component: LegacyRagRedirectChat },
  { path: '/projects/:project_id/diagnostics', component: LegacyRagRedirectDiagnostics },
  { path: '/reporting/audience', component: ReportingAudiencePage, requiresReportsAccess: true },
  { path: '/reporting/funnels', component: ReportingFunnelsPage, requiresReportsAccess: true },
  { path: '/reporting/retention', component: ReportingRetentionPage, requiresReportsAccess: true },
  { path: '/cdp/configs', component: CdpConfigsPage, requiresCdpAccess: true },
  { path: '/cdp/configs/create', component: CdpConfigCreatePage, requiresCdpAccess: true },
  { path: '/cdp/configs/v/:versionId/edit', component: CdpConfigCreatePage, requiresCdpAccess: true },
  { path: '/cdp/configs/v/:versionId', component: CdpConfigVersionPage, requiresCdpAccess: true },
  { path: '/projects/:project_id/cdp/configs', component: CdpConfigsPage, requiresCdpAccess: true },
  { path: '/projects/:project_id/cdp/configs/create', component: CdpConfigCreatePage, requiresCdpAccess: true },
  { path: '/projects/:project_id/cdp/configs/v/:versionId/edit', component: CdpConfigCreatePage, requiresCdpAccess: true },
  { path: '/projects/:project_id/cdp/configs/v/:versionId', component: CdpConfigVersionPage, requiresCdpAccess: true },
  { path: '/cdp/profiles', component: CdpProfilesPage, requiresCdpAccess: true },
  { path: '/cdp/profiles/:profileId', component: CdpProfilePage, requiresCdpAccess: true },
  { path: '/cdp/jobs', component: CdpJobsPage, requiresCdpAccess: true },
  { path: '/storage/csv-upload', component: CsvUploadPage },
  { path: '/storage', component: ProjectStorageExplorerPage },

  // Датасеты — проектный контекст через ?db_name=
  { path: '/datasets', component: DatasetsListPage },
  { path: '/datasets/new', component: DatasetWizardPage },
  { path: '/datasets/:datasetId', component: DatasetPage },
  { path: '/datasets/:datasetId/edit', component: DatasetWizardPage },

  // Feature Store (события, таблицы, шаблонизатор) — проектный контекст через ?db_name=
  // by-name открывает таблицу хранилища, у которой ещё нет карточки
  // Вкладки карточки таблицы — отдельными путями, а не состоянием
  { path: '/feature-store/tables', component: FsTablesListPage },
  { path: '/feature-store/tables/by-name', component: FsTablePage },
  { path: '/feature-store/tables/by-name/events', component: FsTablePage },
  { path: '/feature-store/tables/:tableMetaId', component: FsTablePage },
  { path: '/feature-store/tables/:tableMetaId/events', component: FsTablePage },
  { path: '/feature-store/templates', component: FsTemplatesPage },
  { path: '/feature-store/templates/create', component: FsTemplateCreatePage },
  { path: '/feature-store/templates/:templateId', component: FsTemplatePage },
  { path: '/feature-store/params', component: FsParamsCatalogPage },
  { path: '/feature-store/values', component: FsValuesDiscoveryPage },
  { path: '/feature-store/params/:paramDictId', component: FsParamPage },
  { path: '/feature-store/features', component: FsFeaturesListPage },
  { path: '/feature-store/features/create', component: FsFeatureCreatePage },
  { path: '/feature-store/features/:featureId', component: FsFeaturePage },
  { path: '/feature-store/monitoring', component: MonitoringListPage },
  { path: '/feature-store/monitoring/alerts', component: MonitoringAlertsPage },
  { path: '/feature-store/monitoring/events/:eventId', component: MonitorPage, usePathKey: true },
  { path: '/feature-store/events', component: FsEventsCatalogPage },
  { path: '/feature-store/events/create', component: FsEventEditorPage },
  { path: '/feature-store/events/:eventId', component: FsEventPage },
  { path: '/feature-store/events/:eventId/edit', component: FsEventEditorPage },

  { path: '/projects/:project_id', component: ProjectWorkspacePage },

  // Интеграции и подключения
  { path: '/integrations/create/sources/:source_id', component: AddConnectionPage },
  { path: '/integrations/create/storages/:storage_id', component: AddConnectionPage },
  { path: '/integrations/library/sources', component: ObjectLibraryPage },
  { path: '/integrations/library/storages', component: ObjectLibraryPage },
  { path: '/integrations/library/sources/:category_name', component: ObjectLibraryPage },
  { path: '/integrations/library/storages/:category_name', component: ObjectLibraryPage },
  { path: '/integrations/add-source', component: IntegrationAddSourcePage },
  { path: '/integrations/add-storage', component: IntegrationAddStoragePage },
  { path: '/integrations/create', component: IntegrationConfigPage },
  { path: '/integrations/configure', component: IntegrationConfigureRedirect },
  // Рекомендательные кампании — проектный контекст через ?db_name=
  { path: '/rec/campaigns', component: CampaignsListPage, requiresInferenceAccess: true },
  { path: '/rec/campaigns/new', component: CampaignWizardPage, requiresInferenceAccess: true },
  // Разделы карточки кампании — сегменты пути, а не состояние компонента:
  // на «Проверку» или «Модели» конкретной кампании можно дать ссылку.
  { path: '/rec/campaigns/:campaignId', component: CampaignPage, requiresInferenceAccess: true },
  { path: '/rec/campaigns/:campaignId/stats', component: CampaignPage, requiresInferenceAccess: true },
  { path: '/rec/campaigns/:campaignId/models', component: CampaignPage, requiresInferenceAccess: true },
  { path: '/rec/campaigns/:campaignId/api', component: CampaignPage, requiresInferenceAccess: true },
  { path: '/rec/campaigns/:campaignId/test', component: CampaignPage, requiresInferenceAccess: true },
  // Старый сегмент probe → тот же экран (закладки / внешние ссылки)
  { path: '/rec/campaigns/:campaignId/probe', component: CampaignPage, requiresInferenceAccess: true },
  { path: '/rec/campaigns/:campaignId/edit', component: CampaignWizardPage, requiresInferenceAccess: true },
  { path: '/rec/models', component: ModelsListPage, requiresInferenceAccess: true },
  { path: '/rec/models/:modelId', component: ModelPage, requiresInferenceAccess: true },
  { path: '/rec/placements', component: PlacementsListPage, requiresInferenceAccess: true },
  { path: '/rec/placements/:placementCode', component: PlacementPage, requiresInferenceAccess: true },

  // Цепочки интеграций — проектный контекст через ?db_name=
  // Вкладки карточки — отдельными путями, а не query-параметром
  { path: '/chains', component: ChainsListPage },
  { path: '/chains/:chainId', component: ChainPage },
  { path: '/chains/:chainId/steps', component: ChainPage },
  { path: '/chains/:chainId/runs', component: ChainPage },
  { path: '/chains/:chainId/tasks', component: ChainPage },
  { path: '/chains/:chainId/settings', component: ChainPage },
  { path: '/chains/:chainId/edit', component: ChainEditorPage },

  { path: '/connections', component: UserConnectionsPage },
  { path: '/sources', component: SourcesPage },
  { path: '/storages', component: StoragesPage },
  { path: '/integrations', component: IntegrationsPage },
  { path: '/integrations/:cid', component: IntegrationPage },
  { path: '/integrations/:cid/query', component: IntegrationPage },
  { path: '/sources/:source_id', component: SourceDetailsPage },
  { path: '/tasks', component: TasksPage },

  // Детали источника/хранилища (используются в пайплайне проекта)
  { path: '/source/:source_id', component: ObjectDetailsPage },
  { path: '/storage/:storage_id', component: ObjectDetailsPage },

  // Библиотека объектов
  { path: '/library', component: ObjectLibraryPage },
  { path: '/library/sources', component: ObjectLibraryPage },
  { path: '/library/storages', component: ObjectLibraryPage },
  { path: '/library/:category_name', component: ObjectLibraryPage },
  { path: '/library/sources/:category_name', component: ObjectLibraryPage },
  { path: '/library/storages/:category_name', component: ObjectLibraryPage },
  { path: '/library/sources/:source_id/details', component: ObjectDetailsPage },
  { path: '/library/storages/:storage_id/details', component: ObjectDetailsPage },

  // Fallback - должен быть последним
  { path: '*', component: HomePage },
];

export { AuthPage };
